export default "__VITE_ASSET__DkDkDhs$__"